export default {"src":"/_next/static/media/ndz.7b65e7ac.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};